import axios from 'axios';

const getBaseURL = (env) => {
  switch (env) {
    case 'development':
      return process.env.REACT_APP_DEV_URL;
    case 'stage':
      return process.env.REACT_APP_STAGE_URL;
    case 'production':
      return process.env.REACT_APP_PROD_URL;
    case 'au_development':
      return process.env.REACT_APP_AU_DEV_URL;
    case 'au_stage':
      return process.env.REACT_APP_AU_STAGE_URL;
    case 'au_production':
      return process.env.REACT_APP_AU_PROD_URL;
    default:
      return process.env.REACT_APP_AU_STAGE_URL;
    // return process.env.REACT_APP_STAGE_URL;
  }
};

const getBaseURLStackTwo = (env) => {
  switch (env) {
    case 'stage':
      return process.env.REACT_APP_STAGE_URL_TWO;
    case 'production':
      return process.env.REACT_APP_PROD_URL_TWO;
    case 'au_stage':
      return process.env.REACT_APP_AU_STAGE_URL_TWO;
    case 'au_production':
      return process.env.REACT_APP_AU_PROD_URL_TWO;
    default:
      return process.env.REACT_APP_AU_STAGE_URL_TWO;
  }
};

const client = axios.create({
  baseURL: getBaseURL(process.env.REACT_APP_ENV),
});

const clientTwo = axios.create({
  baseURL: getBaseURLStackTwo(process.env.REACT_APP_ENV),
});

client.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

clientTwo.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

clientTwo.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { clientTwo };

export default client;
